'use es6';

import { gate } from 'hub-http/gates';
import tinymce from 'tinymce';
import { __HS_CORE } from '../constants/plugins';
import { isUngated } from '../utils/settings';
import initContextualToolbarCore from './contextualToolbar';
import initApiPlugin from './plugins/api';
import initDirectionalityPlugin from './plugins/directionality';
import initForcePNewlinePlugin from './plugins/newline';
import initPaddingPlugin from './plugins/padding';
import initSanitizePlugin from './plugins/sanitize';
import initTransformerPlugin from './plugins/transformer';
import initUsagePlugin from './plugins/usage';

// Hack to trick tinymce to NOT try to load the default icon pack.
// Trying to load the pack results in a failed fetch which causes
// subsequent editors on a page to not have their theme loaded.
if (tinymce.IconManager) {
  tinymce.IconManager.add('default', {
    icons: {}
  });
}

// Patch to allow inserting a visual space at the end of a text node
// if the next sibling is a BR tag
const initTrailingSpaceInTextNodePatch = editor => {
  let nextSiblingRef = null;
  editor.on('keydown', evt => {
    if (evt.key === ' ' || evt.keyCode === 32) {
      const rng = editor.selection.getRng();
      const container = rng.startContainer;
      const offset = rng.startOffset;
      if (container.nodeType === Node.TEXT_NODE) {
        // If caret is at the end of the text node, and Chrome has inserted an empty text node
        // we want to mark that sibling node for manually updating the textContent to be ' '
        if (offset === container.length) {
          var _nextSibling$nextSibl, _nextSibling$nextSibl2;
          const nextSibling = container.nextSibling;
          const nextElementSibling = container.nextElementSibling;
          const nextNextSiblingIsEmptyTextNodeOrBR = (nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.nextSibling) === nextElementSibling || (nextSibling === null || nextSibling === void 0 || (_nextSibling$nextSibl = nextSibling.nextSibling) === null || _nextSibling$nextSibl === void 0 ? void 0 : _nextSibling$nextSibl.nodeType) === Node.TEXT_NODE && (nextSibling === null || nextSibling === void 0 || (_nextSibling$nextSibl2 = nextSibling.nextSibling) === null || _nextSibling$nextSibl2 === void 0 ? void 0 : _nextSibling$nextSibl2.length) === 0;
          if ((nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.tagName) === 'BR' || (nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.nodeType) === Node.TEXT_NODE && (nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.length) === 0 && nextNextSiblingIsEmptyTextNodeOrBR && (nextElementSibling === null || nextElementSibling === void 0 ? void 0 : nextElementSibling.tagName) === 'BR') {
            if ((nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.nodeType) === Node.TEXT_NODE && (nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.length) === 0) {
              nextSiblingRef = nextSibling;
            }
          }
        }
      }
    }
  });
  editor.on('keypress', evt => {
    if ((evt.key === ' ' || evt.keyCode === 32) && !!nextSiblingRef) {
      // Manually set the textContent to be a space, then reset the ref
      nextSiblingRef.textContent = ' ';
      nextSiblingRef = null;
    }
  });
};
function corePlugins(editor) {
  initTransformerPlugin(editor);
  initPaddingPlugin(editor);
  initDirectionalityPlugin(editor);
  initUsagePlugin(editor);
  initSanitizePlugin(editor);
  initContextualToolbarCore(editor);
  initForcePNewlinePlugin(editor);
  if (isUngated(editor, gate('Tinymce:EnableTrailingSpaces'))) {
    initTrailingSpaceInTextNodePatch(editor);
  }
  return {
    api: initApiPlugin(editor)
  };
}
export const HS_CORE = __HS_CORE;
tinymce.PluginManager.add(HS_CORE, corePlugins);